<template>
  <div>
    <Loader :class="{ marinTop: mTop }" v-if="loader" />
    <div class="month-box">
      <div class="row">
        <div class="col-md-7" style="width: 50%">
          <p>Миний хэрэглээ</p>
        </div>
        <div class="col-md-5" style="padding-left: 25px; width: 50%">
          <select v-model="selectedMonth" @change="getItemCategory()">
            <option
              v-for="option in options"
              v-bind:key="option.text"
              v-bind:value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="txt-2 text-center">
      <p>{{ this.totalMonth }} ₮</p>
    </div>

    <div class="box-scroll">
      <div v-for="item in details" v-bind:key="item.name">
        <div class="box3">
          <div class="row">
            <div class="col-md-1">
              <div class="box-icon">
                <img :src="require(`@/assets/icon/${item.imgUrl}`)" />
              </div>
            </div>
            <div class="col-md-10" style="margin-left: 5px">
              <p>{{ item.name }}</p>
              <h2>{{ item.amountStr }}</h2>
              <div class="ka-progress" :class="item.graphicPercent"></div>
            </div>
            <div class="box4">
              <p>{{ item.amtPercent }}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/views/plugin/loader";
export default {
  data() {
    return {
      details: {},
      selectedMonth: "",
      totalMonth: 0,
      loader: true,
      mTop: false,
      options: [
        { text: "1-р сар", value: "0" },
        { text: "2-р сар", value: "1" },
        { text: "3-р сар", value: "2" },
        { text: "4-р сар", value: "3" },
        { text: "5-р сар", value: "4" },
        { text: "6-р сар", value: "5" },
        { text: "7-р сар", value: "6" },
        { text: "8-р сар", value: "7" },
        { text: "9-р сар", value: "8" },
        { text: "10-р сар", value: "9" },
        { text: "11-р сар", value: "10" },
        { text: "12-р сар", value: "11" },
      ],
    };
  },
  methods: {
    getItemCategory() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      if (this.selectedMonth === "") {
        var date = new Date();
        this.selectedMonth = date.getMonth();
      }
      var cardHolderInfId = user.cardHolderInfId;
      var type = this.selectedMonth;
      var isPartner = 1;
      this.loader = true;
      // this.$axiosApi;
      this.$bonusApi
        .post(
          `bonus-card/category`,
          // `card/category`,
          {
            tokenId,
            cardHolderInfId,
            type,
            isPartner,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var results = response.data;
          if (results.status === 0) {
            this.details = results.details;
            this.totalMonth = new Intl.NumberFormat().format(
              results.totalMonth
            );
            this.loader = false;
          }
        })
        .catch((error) => {
          this.$insProgress.finish();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    returnImage(img) {
      return img + ".png";
    },
  },
  components: {
    Loader,
  },
  created() {
    this.getItemCategory();
  },
};
</script>
<style>
.month-box {
  background: #1660ab;
  width: 100%;
  padding: 2px 5px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  position: relative;
}
.month-box:before {
  content: "";
  top: 0;
  left: 160px;
  width: 1px;
  height: 32px;
  background: #fff;
  position: absolute;
}
.month-box p {
  margin: 0;
  padding: 0;
  font-size: 14px;
  padding-left: 5px;
  padding-top: 2px;
  color: #fff;
  font-weight: bold;
  line-height: 1.8em;
}
.month-box select {
  background: none;
  color: #fff;
  border: none;
  font-size: 14px;
}
.month-box option {
  color: #000;
}
.txt-2 {
  margin: 0;
  background: #fff;
}
.txt-2 p {
  color: #1660ab;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  border-bottom: 1px solid #e4e4e4;
}

@media screen and (max-width: 767px) {
  .month-box {
    margin-top: 10px;
  }
  .col-md-5 {
    width: 41.666667%;
    padding-left: 15px;
  }
  .col-md-6 {
    width: 50%;
    padding: 0 15px;
  }
  .col-md-7 {
    width: 58.333333%;
    padding-left: 15px;
  }
}
</style>
